var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasetBannerLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 72,
    viewBox: "0 0 304 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.884 189.803C288.244 87.3705 59.7707 75.8743 197.341 -20.9653",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.371 181.035C251.331 80.1735 67.7467 69.7898 182.596 -31.9576",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.797 172.348C214.416 72.9815 75.5862 63.728 167.79 -42.8689",
    stroke: "url(#paint2_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.285 163.582C177.503 65.7872 83.563 57.6462 153.121 -53.8003",
    stroke: "url(#paint3_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.715 154.891C140.533 58.6671 91.4811 51.6386 138.259 -64.6398",
    stroke: "url(#paint4_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.141 146.203C103.633 51.6091 99.3954 45.6349 123.452 -75.5511",
    stroke: "url(#paint5_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.629 137.438C66.7796 44.3391 107.431 39.4774 108.708 -86.5407",
    stroke: "url(#paint6_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.98 128.691C29.7308 37.1643 115.196 33.357 93.8277 -97.5106",
    stroke: "url(#paint7_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.469 119.926C-7.1813 29.97 123.173 27.2752 79.0837 -108.5",
    stroke: "url(#paint8_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.895 111.237C-44.0966 22.7768 131.088 21.2703 64.2776 -119.413",
    stroke: "url(#paint9_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3823 102.471C-81.0097 15.5817 139.064 15.1877 49.6074 -130.345",
    stroke: "url(#paint10_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8103 93.7848C-117.982 8.46714 146.905 9.12753 34.8031 -141.255",
    stroke: "url(#paint11_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 3.99609,
    r: 25,
    fill: "url(#paint12_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 253.592,
    y1: 125.879,
    x2: 140.41,
    y2: 37.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 241.045,
    y1: 117.002,
    x2: 129.195,
    y2: 29.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 228.514,
    y1: 108.197,
    x2: 116.725,
    y2: 21.2005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 215.991,
    y1: 99.3255,
    x2: 102.06,
    y2: 10.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 203.466,
    y1: 90.393,
    x2: 87.1762,
    y2: -0.106627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 190.928,
    y1: 81.4367,
    x2: 72.3167,
    y2: -10.8696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 178.402,
    y1: 72.4675,
    x2: 57.4852,
    y2: -21.6338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 165.891,
    y1: 63.5064,
    x2: 42.663,
    y2: -32.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 153.399,
    y1: 54.5577,
    x2: 27.8439,
    y2: -43.1525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 140.689,
    y1: 46.0799,
    x2: 12.7091,
    y2: -53.5175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 127.39,
    y1: 38.3909,
    x2: -3.0365,
    y2: -63.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 113.808,
    y1: 31.0505,
    x2: -19.0625,
    y2: -72.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109 -9.50391) rotate(68.0704) scale(41.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336.92,
    height: 180.597,
    fill: "white",
    transform: "translate(192.754 204.059) rotate(-142.109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetBannerLeft);
export default __webpack_public_path__ + "static/media/dataset_banner-left.899f87453db488a9736f1940e712aa12.svg";
export { ForwardRef as ReactComponent };